export const yandexMetricaCounter = 73097359;

// https://segment.com/docs/connections/spec/page/
// https://segment.com/docs/connections/spec/track/

export function identifyUserAnalytics(user, traits) {
    if (!user) {
        window.analytics && window.analytics.identify('', { subscriptionStatus: 'inactive' });
        return;
    }
    const userID = user.lawsUser.id || user.newsUser.id;

    window.analytics &&
        window.analytics.identify(`${userID}`, {
            name: user.username,
            group_name: user.group_name,
            email: user.email,
            laws_user_id: user.lawsUser.id,
            news_user_id: user.newsUser.id,
            client: user.client,
            ...traits,
        });
}

export function resetAnalytics() {
    window.analytics && window.analytics.reset();
}

export function pageAnalytics(name, properties) {
    window.analytics && window.analytics.page(name, properties);
}

export function trackPageTransition(properties, options) {
    window.analytics &&
        window.analytics.page('Переход на страницу документа', { ...properties, category: 'transitions' }, options);
}

export function trackAddFavorites(properties, options) {
    window.analytics &&
        window.analytics.track(
            'Добавление документа в избранное',
            { ...properties, category: 'ecosystem actions' },
            options
        );
}

export function trackAddFavoritesError(properties, options) {
    window.analytics &&
        window.analytics.track(
            'Ошибка добавления документа в избранное',
            { ...properties, category: 'ecosystem actions' },
            options
        );
}

export function trackImportance(actionName, properties, options) {
    window.analytics && window.analytics.track(actionName, { ...properties, category: 'importance' }, options);
}

export function trackEcosystemAction(actionName, properties, options) {
    window.analytics && window.analytics.track(actionName, { ...properties, category: 'ecosystem actions' }, options);
}



// WEBPACK FOOTER //
// ./src/utils/analytics.js